// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2qMSN","name":"ConsentHeader_name__2Jqdd","birthday":"ConsentHeader_birthday__f18rG","skeleton":"ConsentHeader_skeleton__2wA88"};